<template>
  <div id="app">
    <Nav :showDropdown="showDropdown" @toggle-dropdown="toggleDropdown" />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";
import "./styles/application.scss";

export default {
  name: "App",
  components: {
    Nav,
    Footer
  },
  data: () => ({
    showDropdown: false
  }),
  methods: {
    toggleDropdown: function() {
      this.showDropdown = !this.showDropdown;
    }
  }
};
</script>
